import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import Modal from "react-animated-modal";
import Modal from 'react-bootstrap4-modal';
import { PulseLoader } from 'halogenium';
import ResponsivePageLayoutA from '../../components/merchant/components/WaiterOrder/ResponsivePageLayoutA';
import AppData from '../../Model/AppData' ;
import OrderHelper from '../OrderHelper/OrderHelper';
import AnimatedModal from "react-animated-modal";
import { handleAjaxError } from '../../util/api';
import TableSessionHelper from '../../Model/TableSession';
import PendingQueue from '../../components/merchant/components/BackgroundQueue/PendingQueue';

var portalRoot = null;

class MergeOrderModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#merge-order-modal').length == 0) {
            $('body').prepend('<div id="merge-order-modal"></div>')
        }
        portalRoot = document.getElementById("merge-order-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class MergeOrderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedTicketIds: [],
            newTicketTotalPrice: 0.0,
            highlightedTicketId: null,
        }
    }
    isLoading(isLoading) {
        if (!this.unmounted) {
            this.setState({isLoading})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        const sessions = this.getTableSessions()
        const highlightedTicketId = (sessions && sessions.length > 0 && sessions[0].id) || null
        this.setState({highlightedTicketId})
    };
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    getButtons = () => {
        if (this.props.buttonLayout == "vertical") {
            return (
                <div className="mt-3">
                    <button id="merge-order-modal-btn-yes" onClick={this.props.onYes} className={"btn btn-block mb-2 "+(this.props.isYesDestructive ? "btn-danger" : "btn-success")}>{lang.confirm}</button>
                    <button id="merge-order-modal-btn-no" onClick={this.props.onNo} className="btn btn-default btn-block">{lang.cancel}</button>
                </div>
            )
        }
        else {
            // Default is horizontal layout
            return (
                <div style={{textAlign:"right"}}>
                    <button onClick={this.props.onNo} className="btn btn-primary btn-sm mr-2">{lang.cancel}</button>
                    <button onClick={this.props.onYes} className="btn btn-primary btn-sm">{lang.confirm}</button>
                </div>
            )
        }
    }
    onTicketSelected = (sessionId) => {
        let selectedTicketIds = [...this.state.selectedTicketIds]
        const index = selectedTicketIds.indexOf(sessionId)
        if (index === -1) {
            selectedTicketIds.push(sessionId)
        }
        else {
            selectedTicketIds.splice(index,1)
        }
        const newTicketTotalPrice = this.calculateNewTicketPrice(selectedTicketIds)
        this.setState({selectedTicketIds, newTicketTotalPrice})
    }
    calculateNewTicketPrice = (selectedTicketIds) => {
        const newTotalPrice = selectedTicketIds.reduce((accumulatedPrice,sessionId) => {
            return accumulatedPrice + OrderHelper.getTotalPrice(this.props.app,sessionId)
        },0)
        return newTotalPrice
    }

    getTableSessions = () => {
        return TableSessionHelper.getSessionsForTableWithActiveOrders({id:this.props.tableId})
    }

    toCurrency = (price, currencyName) => {
        let finalPrice = parseFloat(price)
        return currencyName+" " + (finalPrice > 0 ? finalPrice.toFixed(2) : "0.00")
    }
    onMergeClicked = () => {
        if (this.state.selectedTicketIds.length < 2) {
            this.setState({message: lang.select_2_or_more_ticket_to_merge})
            return
        }
        let selectedTicketIds = [...this.state.selectedTicketIds]
        this.setState({
            isLoading: true,
        })

        // For UX consideration, sort selectedTicketIds so that current session that
        // user selected to be first item in array. API will merge all other sessions
        // into the first session. If admin viewing Session B, and we merge session B
        // into A, then AdminOrder item listing still will show listing of Session B,
        // which is empty now since orders from Session B had been merged into Session A.
        // User will have to go back to table listing and reenter AdminOrder to see the
        // updated order listing.
        // To avoid bad UX, if user is viewing Session B, we shall merge orders from Session A into 
        // Session B.
        const currentSessionId = this.props.app.state.currentSession.id
        let index = selectedTicketIds.indexOf(currentSessionId)
        if (index !== -1) {
            // Current session is in the list of sessions to merge
            if (index != 0) {
                // Current session is not at first position, adjust it
                // 1. Remove it from array
                // 2. Add it as first element
                selectedTicketIds.splice(index,1)
                selectedTicketIds.unshift(currentSessionId)
            }
        }

        let me = this
        let table = this.props.app.state.tables.find((item) => item.id == me.props.tableId)
        let a = {
            action: () => {
                $.ajax({
                    url: `/merchant/api/order/merge`,
                    type: "post",
                    data: {
                        table_session_ids: selectedTicketIds
                    },
                    success: (response) => {
                    }
                })
                .fail(handleAjaxError)
                .done(() => {
                    PendingQueue.remove(a)
                })
            },
            name: "Merging Table " + table.name
        }
        PendingQueue.add(a)

        // Add a small delay for better UX
        setTimeout(this.closeMergeOrderModal(), 500)
    }
    closeMergeOrderModal = () => {
        this.props.onNegativeClicked()
        this.setState({
            isLoading: false,
        })
    }
    render() {
        let ratio = this.props.ratio
        if (!(ratio && Array.isArray(ratio) && ratio.length == 2)) {
            ratio = [1,4]
        }
        const leftRatio = ratio[0] + " 0 100px"
        const rightRatio = ratio[1] + " 0 200px"
        return (
            <MergeOrderModalPortal>
                <Modal visible={true} onClickBackdrop={this.props.onNegativeClicked} dialogClassName="modal-lg" fade>
                {
                    this.state.message && 
                    <div style={{position:"relative",width:"100%"}}>
                        <AnimatedModal
                            visible={true}
                            closemodal={() => this.setState({message:null})}
                            type={"bounceIn"}>
                            <div className="menu-modal" style={{padding:"20px"}}>
                                <div >
                                    {this.state.message}
                                </div>
                                <div style={{textAlign:"right"}}>
                                    <button onClick={() => this.setState({message:null})} className="btn btn-primary btn-sm">OK</button>
                                </div>
                            </div>
                        </AnimatedModal>
                    </div>
                }
                    <div className="modal-header">
                        <h5 className="modal-title">{lang.merge_order}</h5>
                    </div>
                    <div className="modal-body">
                        <div style={{display:"flex"}} className="mb-1">
                            <div style={{flex:"1 0 100px"}}>
                                <button 
                                    className="btn btn-sm btn-primary" 
                                    onClick={() => {
                                        const allSessionIds = this.getTableSessions().map(session => session.id)
                                        const isAllSelected = this.state.selectedTicketIds.length == allSessionIds.length
                                        let selectedTicketIds = isAllSelected ? [] : allSessionIds
                                        const newTicketTotalPrice = this.calculateNewTicketPrice(selectedTicketIds)
                                        this.setState({selectedTicketIds, newTicketTotalPrice})
                                    }}>
                                    {lang.select_all}
                                </button>
                            </div>
                            <div style={{flex:"1 0 100px",textAlign:"right"}}>
                                {lang.new_ticket_total_price + ": "}
                                <span style={{fontSize: "14pt"}} className="ml-2">
                                    <strong>{this.toCurrency(this.state.newTicketTotalPrice, this.props.app.state.currencyName)}</strong>
                                </span>
                            </div>
                        </div>
                        <div style={{display: "flex"}}>
                            <div style={{flex: leftRatio}}>
                                <TicketList 
                                    {...this.props} 
                                    tableSessions={this.getTableSessions()}
                                    setHighlightedTicketId={(highlightedTicketId) => this.setState({highlightedTicketId})}
                                    highlightedTicketId={this.state.highlightedTicketId}
                                    selectedTicketIds={this.state.selectedTicketIds} 
                                    onTicketSelected={this.onTicketSelected} />
                            </div>
                            {/* <div style={{width:"1px", backgroundColor:"#aaa"}}></div> */}
                            <div style={{flex: rightRatio, border: "1px solid #d3e0e9", marginLeft:"-1px", padding:"8px"}}>
                                {lang.order_items}
                                <OrderListing 
                                    app={this.props.app}
                                    orders={OrderHelper.getOrdersOfSession(this.props.app, this.state.highlightedTicketId)} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        {
                            this.state.isLoading ? 
                            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                            <>
                                <button type="button" className="btn btn-secondary" onClick={this.props.onNegativeClicked}>
                                    {lang.cancel}
                                </button>
                                <button type="button" className="btn btn-primary" onClick={this.onMergeClicked}>
                                    {lang.btn_text_merge_order}
                                </button>
                            </>
                        }
                        
                    </div>
                </Modal>
            </MergeOrderModalPortal>
        )
    }
}

function TicketList({app, tableId, onTicketSelected, selectedTicketIds, highlightedTicketId, setHighlightedTicketId, tableSessions}) {
    const handleCheckboxClicked = (e, sessionId) => {
        e.stopPropagation();
        onTicketSelected(sessionId)
    }
    let ticketIndex = 1;
    let options = tableSessions.map( session => {
        const className = `list-group-item` + (highlightedTicketId == session.id ? " active" : "")
        const style = highlightedTicketId == session.id ? {borderRight: "none"} : {}
        const totalPrice = OrderHelper.getTotalPriceAsString(app,session.id)

        return <li className={className} key={session.id} value={session.id} onClick={() => setHighlightedTicketId(session.id)} style={style}>
            <div style={{display: "flex", flexWrap: "wrap"}}>
                <div style={{flex: "0 1 30px", height:"30px", textAlign: "center", marginLeft:"-10px"}} onClick={(e) => handleCheckboxClicked(e, session.id)}>
                    <input type="checkbox" checked={selectedTicketIds.indexOf(session.id) !== -1} readOnly/> 
                </div>
                <div style={{flex: "1 0 50px"}}>
                    {lang.ticket} {ticketIndex++}
                </div>
                <div style={{flex: "1 0 50px", textAlign:"right", whiteSpace:"nowrap"}}>
                    {totalPrice}
                </div>
            </div> 
        </li>
    })
    return <>
        <ul className="list-group">
            {options}
        </ul>
    </>
}

function showTakeAwayTag(app, value){
    return (
        <div>
            <span><span>&#10033;</span>{lang.take_away}</span>
            {value == 0 ? "" :
                <div style={{float:"right" }}>
                    {"+ "+app.state.currencyName+" " + (value * 1).toFixed(2)}
                </div>
            }
        </div>
    )
}
function showVariationsTag(app,order){
    let addons = app.state.variation.addons.filter((item) => item.item_id == order.menu_item_id)
    let options = app.state.variation.options.filter((item) => item.item_id == order.menu_item_id)
    let variations = addons.concat(options)
    let variation_ary = (order.variation_ary != undefined ? order.variation_ary : variations.filter((item) => order.variation_ids.includes(item.id)))
    let li = variation_ary.map((variation) => {
        let value = Math.abs((variation.price * 1)).toFixed(2)
        value = order.quantity * value
        let price = (variation.price > 0 ?  "+ " : "- ") + app.state.currencyName+" " + (value * 1).toFixed(2)
        return(
            <div key={"variation-" + variation.id}>
                <span>{variation.name}</span>
                {variation.price == 0 ? "" :
                    <div style={{float:"right" }}>
                        {price}
                    </div>
                }
            </div>
        )})
    return li
}
function getOrderDescription(app, order) {
    let menuItem = app.state.menuItems.find((item) => item.id == order.menu_item_id)

    if (!menuItem) {
        return null
    }

    let value = menuItem.take_away_charge == 0 ? 0 : menuItem.take_away_charge * order.quantity
    return (
        (order.variation_ids == null && !order.take_away) ? null :
            <div className={'clearfix'} style={{ marginBottom: "5px" , color: order.order_status == "accepted"? "#66192d" : ""}}>
                <div className={'btn-group'} role="group" aria-label="Second group" style={{ display: "block" }}>
                    {!order.take_away ? null :
                        showTakeAwayTag(app, value)
                    }
                    {!order.variation_ids? null:
                        showVariationsTag(app, order)
                    }
                </div>
            </div>
    )
}


function OrderListing({orders, app}) {
    return <ul>
        {orders.map((order) => {
            let listClass = "admin-order-" + order.id;

            let selected = false
            let totalPrice = 0;
            let isWaitingForData = false;
            let menuItem = app.state.menuItems.find((item) => item.id == order.menu_item_id)
            if(menuItem){
                if (menuItem.is_price_per_weight || menuItem.is_price_per_pax) {
                    totalPrice = order.order_total
                }
                else if (order.option_ids) {
                    let choice = app.state.variation.choices.find((item) => item.id == order.option_ids[0])
                    if (choice) {
                        totalPrice = parseFloat(choice.price);
                    }
                    else {
                        isWaitingForData = true;
                    }
                }
                else {
                    totalPrice = parseFloat(menuItem.price);
                }
                totalPrice = totalPrice * order.quantity
            }

            const getTotalPrice = () =>  {
                if (isWaitingForData) {
                    return "..."
                }
                else {
                    return app.state.currencyName+" " + (totalPrice * 1).toFixed(2)
                }
            }

            return (
                <div style={{position:"relative", overflow:"auto", padding:"10px"}} data-id={order.id} key={order.id}
                    className={(selected)? "admin-order-selected-list " + listClass : listClass} >

                    <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        <div className="item-title" style={{fontWeight: "bold", color: order.order_status == "accepted"? "#66192d" : "", 
                            fontStyle: order.order_status == "void"? "italic": "normal", fontSize: "10pt" }}> 
                            <span style={{width:"65%", display:"inline-block"}}>
                                {order.order_status == "void"? <del>{order.quantity + "x " + order.desc}</del> : order.quantity + "x " + order.desc} 
                            </span>
                            <span style={{float:"right" }}>
                                {/* {"RM " + (order.order_total * 1).toFixed(2)} */}
                                {order.order_status == "void" ? <del>{app.state.currencyName+" " + (totalPrice * 1).toFixed(2)}</del> : getTotalPrice()}
                            </span>
                        </div>
                    </div>
                    {order.order_status == "void"? "" : getOrderDescription(app, order)}
                </div>
            )
        })}
    </ul>
}

MergeOrderModal.defaultProps = {
    buttonLayout: "default",
    isYesDestructive: false
}
export default MergeOrderModal;